export function getMastodonHandleFromLink(mastodonLink: string): string {
  if (mastodonLink.startsWith('https://mastodon.social/')) {
    return (
      mastodonLink.replace('https://mastodon.social/', '') + '@mastodon.social'
    );
  }

  return mastodonLink;
}
